export interface IFile {
  name: string;
  extension: string;
  mime_type: string;
  type: string;
  path: string;
  url: string;
  title: string;
  // COMNETフォルダ配下のファイルは"comnet"。それ以外は未設定（通常ファイル）。
  source?: string;
}

export interface IFileToUpload {
  key: string;
  value?: File | File[];
}

export enum FileManagementType {
  FILE = "file",
  FOLDER = "directory",
}
